import React from 'react';
import PropTypes from 'prop-types';

import { AgGridReact } from 'ag-grid-react';
import 'common/components/ag-grid/registerAgGridModules';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const getAgGridProps = (rowData = []) => {
  return {
    defaultColDef: {
      enableRowGroup: false,
      enablePivot: false,
      enableValue: false,
      width: 100,
      sortable: false,
      resizable: false,
      filter: false,
    },
    headerHeight: 32,
    rowHeight: 32,
    // rowSelection: 'multiple',
    // suppressRowClickSelection: true,
    rowData,
    pivotPanelShow: 'never',

    // onRowSelected: (row) => console.log(row),

    // style color row
    rowClassRules: {
      'new-row': ({ data }) => data?.state === 'Added',
      'old-row': ({ data }) => !data?.state !== 'Added',
    },
  };
};

const GridLinkAssets = ({ columns, rowData, dragOver = false }) => {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div
        className={
          dragOver
            ? 'grid-link-assets-container--drag'
            : 'grid-link-assets-container'
        }
      >
        <div id='my-grid-link-asset' className='ag-theme-alpine'>
          <AgGridReact theme="legacy" {...getAgGridProps(rowData)} columnDefs={columns} />
        </div>
      </div>
    </div>
  );
};

GridLinkAssets.prototype = {
  columns: PropTypes.array,
  rowData: PropTypes.array,
  dragOver: PropTypes.bool,
};

export default GridLinkAssets;
